<template>
    <div>
        <div
            class="c-tr"
            :class="{
                '--recentlySelected': recentlySelectedProductIds.includes(
                    product.id
                )
            }"
        >
            <div class="c-tr__row">
                <div class="c-td is-5">
                    <div v-if="isMainProduct">
                        <span class="typo-label">Zdjęcie w aplikacji</span>
                        <ui-checkbox-input
                            class="o-tableAddPromoProducts__productImg"
                            :name="`np-main_photo-${product.id}`"
                            :value="
                                form.step3.main_image_dict_product_id.value ===
                                    product.id
                            "
                            @change="chooseMainImage(product, $event)"
                            label=""
                        />
                    </div>
                </div>
                <div class="c-td is-8">
                    <slot name="showMoreBtn"></slot>
                </div>
                <div class="c-td is-6 d-flex">
                    <img
                        v-if="
                            product.image &&
                                product.image.urls &&
                                product.image.urls.small
                        "
                        :src="product.image.urls.small"
                    />
                    <a-icon v-else icon="NoImg" />
                </div>
                <div class="c-td is-1">
                    <span class="typo-label">Nazwa (SKU)</span>
                    {{ product.name }}
                    <p class="mb-0 d-block d-lg-none">
                        <strong>EAN:</strong>
                        {{ product.ean }}
                    </p>
                </div>
                <div class="c-td is-2">
                    <span class="typo-label">EAN</span>
                    {{ product.ean }}
                </div>
                <div
                    v-if="
                        isAnyNoEanProduct(products) &&
                            form.step2.merchants.value.length === 1
                    "
                    class="c-td is-3 form-group"
                >
                    <div v-if="isMainProduct">
                        <span class="typo-label">Kod lokalny</span>
                        <the-input
                            :disabled="product.ean_present"
                            :text="product.merchant_prices[0].alternative_ean"
                            @input="
                                onLocalCodeChange(
                                    product.merchant_prices[0].merchant_id,
                                    $event,
                                    product.id
                                )
                            "
                            @change="
                                checkIfEanExists(product, $event.target.value)
                            "
                            :invalid="
                                $store.getters.isNewPromoLocalCodeInvalid(
                                    product.merchant_prices[0].merchant_id,
                                    product.merchant_prices[0].alternative_ean
                                )
                            "
                            invalid-feedback="Kod musi być unikalny"
                            validation="localCode"
                            class="mb-0 o-tableAddPromoProducts__localCode"
                        />
                    </div>
                </div>
                <div class="c-td is-3" :class="{ '--productSets': isMix }">
                    <div v-if="isMainProduct">
                        <template v-if="isMix">
                            <span class="typo-label">Waga</span>
                            <the-input
                                :text="'1'"
                                :readonly="true"
                                class="text-right"
                            />
                        </template>
                        <template>
                            <span class="typo-label"
                                >{{
                                    !product.ean_present &&
                                    form.step2.merchants.value.length !== 1
                                        ? 'Cena w promocji, kod lokalny'
                                        : isTypeWeight
                                        ? 'Cena / 1 kg'
                                        : 'Ceny'
                                }}
                            </span>
                            <the-btn
                                v-if="selectedMerchants.length > 1"
                                @click.native="openProductPrices(product)"
                                >Dostosuj</the-btn
                            >
                            <money-input
                                v-else
                                class="mb-0 o-tableAddPromoProducts__productPrice"
                                :price="+product.merchant_prices[0].promo_price"
                                @onChange="
                                    form.step3.invalid = ''
                                    onPromoPriceChange(
                                        product.merchant_prices[0].merchant_id,
                                        $event,
                                        product.id
                                    )
                                "
                            ></money-input>
                        </template>
                    </div>
                </div>
                <div class="c-td is-4" :class="{ '--productSets': isMix }">
                    <div v-if="isMainProduct">
                        <span class="typo-label">Cena poza promocją</span>
                        <the-btn
                            v-if="selectedMerchants.length > 1"
                            @click.native="
                                openProductPrices(
                                    product,
                                    isMix ? productSetId : undefined
                                )
                            "
                            >Dostosuj</the-btn
                        >
                        <money-input
                            v-else-if="isMix"
                            class="mb-0"
                            :price="
                                +productSet.products.value.find(
                                    p => p.id === product.id
                                ).merchant_prices[0].normal_price
                            "
                            @onChange="
                                productSet.products.value.find(
                                    p => p.id === product.id
                                ).merchant_prices[0].normal_price = $event
                            "
                        />
                        <money-input
                            v-else
                            class="mb-0"
                            :price="+product.merchant_prices[0].normal_price"
                            @onChange="
                                form.step3.invalid = ''
                                onNormalPriceChange(
                                    product.merchant_prices[0].merchant_id,
                                    $event,
                                    product.id
                                )
                            "
                        ></money-input>
                    </div>
                </div>
                <div class="c-td is-7 o-tableAddPromoProducts__productDel">
                    <v-popover v-if="isMainProduct" offset="16">
                        <the-btn btn-class="btn-danger btn-icon is-danger"
                            ><a-icon width="24px" height="21px" icon="Bin"
                        /></the-btn>

                        <template slot="popover">
                            <popover-confirm
                                message="Czy na pewno chcesz usunąć produkt?"
                                @confirmed="
                                    chooseMainImage(product, false)
                                    addOrRemoveProduct(product)
                                "
                            />
                        </template>
                    </v-popover>
                </div>
            </div>
            <div
                v-if="isMainProduct && eanErrors"
                class="c-tr__row"
                style="max-width: none;"
            >
                <alt-ean-warning
                    :alt-ean-error="
                        eanErrors.find(el =>
                            selectedMerchantIds.includes(el.merchant_id)
                        )
                    "
                    class="ml-auto"
                />
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import { addNewPromo } from '@/mixins/addNewPromo'
import { setTableFlex } from '@/mixins/setTableFlex'
import AltEanWarning from '@/components/promotions/altEans/AltEanWarning.vue'

export default {
    mixins: [setTableFlex, addNewPromo],
    props: {
        productSetId: {
            type: Number,
            required: false
        },
        product: {
            type: Object,
            required: true
        },
        productSet: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            eanErrors: null
        }
    },

    components: {
        AltEanWarning
    },

    methods: {
        addOrRemoveProduct(product) {
            this.toggleProduct(
                product,
                this.isMix ? this.productSetId : undefined
            )
        },

        async checkIfEanExists(product, localCode) {
            if (!this.$store.getters.isProductEansPermission) return

            if (!localCode) {
                this.$set(product, 'eanErrors', null)
                this.eanErrors = null
                return
            }

            const res = await this.$store.dispatch('checkIfEansExist', [
                {
                    alternative_ean: localCode,
                    merchant_id: this.selectedMerchants[0].id
                }
            ])

            let errors = null
            if (res.length) {
                errors = res.filter(error => error.ean !== product.ean)
            }
            this.$set(product, 'eanErrors', errors)
            this.eanErrors = errors
        }
    },

    computed: {
        selectedMerchantIds() {
            return this.selectedMerchants.map(el => el.id)
        },
        products() {
            return this.isMix
                ? this.productSet.products.value
                : this.form.step3.products.value
        },
        isMainProduct() {
            return this.product.main
        }
    }
}
</script>
